/**
 * Formatage des notes pour affichage : toujours 2 décimales, virgule française.
 * Ex: 10 → "10,00", 11.5 → "11,50", null → "—"
 */
export const formatNote = (
  n: number | string | null | undefined,
  options: { placeholder?: string; precision?: number } = {}
): string => {
  const placeholder = options.placeholder ?? '—';
  const precision = options.precision ?? 2;

  if (n === null || n === undefined || n === '') return placeholder;
  const num = typeof n === 'string' ? parseFloat(n) : n;
  if (Number.isNaN(num)) return placeholder;
  return num.toFixed(precision).replace('.', ',');
};

/** Borne stricte d'une note dans [0, 20] avec arrondi 2 décimales. */
export const isNoteValide = (n: number | null | undefined): boolean => {
  if (n === null || n === undefined) return true; // null = non saisie, OK
  return typeof n === 'number' && !Number.isNaN(n) && n >= 0 && n <= 20;
};
